import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function PrivateVideoPlayer({ asset }) {
  const [source, setSource] = useState("");
  const [error, setError] = useState("");
  const orientation = asset?.safe_metadata?.orientation || "landscape";

  useEffect(() => {
    if (!asset?.media_id) return undefined;
    let active = true;
    let objectUrl = "";
    setError("");
    api.get(`/private-media/assets/${asset.media_id}/content`, { responseType: "blob" })
      .then(({ data }) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(data);
        setSource(objectUrl);
      })
      .catch(() => { if (active) setError("Не удалось загрузить приватное видео"); });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [asset?.media_id]);

  return <div className="rounded-2xl border border-[#DDCDB6] bg-[#201B18] p-3" data-testid="private-video-player">
    <div className={`mx-auto overflow-hidden rounded-xl bg-black ${orientation === "vertical" ? "aspect-[9/16] max-h-[70vh] max-w-sm" : "aspect-video w-full"}`}>
      <video
        src={source}
        controls
        playsInline
        preload="metadata"
        className="h-full w-full object-contain"
        aria-label="Приватное видео"
      />
    </div>
    {error && <div className="mt-3 text-sm text-[#FFD9D2]" role="alert">{error}</div>}
  </div>;
}
